<template>
  <div class="loading-page">
    <div class="loading-container">
      <div class="loading-header">
        <div class="logo-icon">
          <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <h1 class="title">招聘管理系统</h1>
        <p class="subtitle">正在加载系统权限...</p>
      </div>

      <div class="loading-content">
        <div class="loading-section">
          <div class="loader">
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
            <div class="loader-text">正在获取权限...</div>
          </div>
        </div>

        <div class="status-section">
          <transition name="fade" mode="out-in">
            <div :key="statusText" class="status-item">
              <i :class="statusIcon" class="status-icon"></i>
              <span class="status-text">{{ statusText }}</span>
            </div>
          </transition>
        </div>

        <div class="progress-section">
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: progressWidth + '%' }"></div>
          </div>
          <span class="progress-text">{{ progressText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkPathInAuth, fetchAndStoreAuthRouter, getFirstAccessibleRoute } from '../../utils/authRouter';

export default {
  name: 'LoadingPage',
  data() {
    return {
      progress: 0,
      statusIndex: 0,
      statusTexts: [
        '正在验证用户身份...',
        '正在获取权限信息...',
        '正在加载菜单配置...',
        '正在初始化系统...',
        '即将进入系统...'
      ],
      statusIcons: [
        'el-icon-user',
        'el-icon-key',
        'el-icon-menu',
        'el-icon-setting',
        'el-icon-check'
      ]
    };
  },
  computed: {
    statusText() {
      return this.statusTexts[this.statusIndex];
    },
    statusIcon() {
      return this.statusIcons[this.statusIndex];
    },
    progressWidth() {
      return this.progress;
    },
    progressText() {
      return `${Math.round(this.progress)}%`;
    }
  },
  created() {
    const iuId = localStorage.getItem('iuId');
    if (!iuId) {
      this.$router.push('/dologin');
      return;
    }
    this.startLoading();
  },
  methods: {
    async startLoading() {
      const progressTimer = setInterval(() => {
        if (this.progress < 90) {
          this.progress += Math.random() * 10;
        }
      }, 200);

      const statusTimer = setInterval(() => {
        if (this.statusIndex < this.statusTexts.length - 1) {
          this.statusIndex++;
        }
      }, 400);

      try {
        const authList = await fetchAndStoreAuthRouter();

        clearInterval(progressTimer);
        clearInterval(statusTimer);

        this.progress = 100;
        this.statusIndex = this.statusTexts.length - 1;

        setTimeout(() => {
          this.navigateByRole(authList);
        }, 500);
      } catch (error) {
        console.error('加载权限失败:', error);
        clearInterval(progressTimer);
        clearInterval(statusTimer);

        this.$message.error('获取权限失败，请重新登录');
        this.$router.push('/dologin');
      }
    },

    navigateByRole(authList) {
      if (!authList || authList.length === 0) {
        this.$message.warning('暂无权限，请联系管理员');
        this.$router.push('/dologin');
        return;
      }

      const savedPath = localStorage.getItem('recording_path');

      if (savedPath) {
        const hasPermission = checkPathInAuth(savedPath, authList);
        if (hasPermission) {
          this.$router.push(savedPath);
          return;
        }
      }

      const firstRoute = getFirstAccessibleRoute(authList);
      if (firstRoute) {
        this.$router.push(firstRoute);
      } else {
        this.$message.warning('暂无访问权限');
        this.$router.push('/dologin');
      }
    }
  }
};
</script>

<style scoped>
.loading-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-image: linear-gradient(45deg, #2c3e50, #27ae60, #2980b9, #8e44ad);
  animation: bganimation 15s infinite;
}

@keyframes bganimation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.loading-container {
  width: 400px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.loading-header {
  background: linear-gradient(135deg, #121212 0%, #333 100%);
  padding: 30px 20px;
  text-align: center;
  color: #fff;
}

.logo-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
}

.title {
  font-size: 22px;
  margin: 0 0 8px;
  font-weight: 600;
}

.subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
}

.loading-content {
  padding: 30px 20px;
  background: #f5f7fa;
}

.loading-section {
  margin-bottom: 30px;
}

.loader {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.loader-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top-color: rgba(64, 158, 255, 0.5);
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.loader-ring:nth-child(2) {
  width: 90%;
  height: 90%;
  border-top-color: rgba(108, 66, 232, 0.5);
  animation-duration: 1.2s;
  animation-direction: reverse;
}

.loader-ring:nth-child(3) {
  width: 70%;
  height: 70%;
  border-top-color: rgba(103, 194, 58, 0.5);
  animation-duration: 0.9s;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-text {
  position: absolute;
  bottom: -30px;
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}

.status-section {
  margin-bottom: 25px;
  height: 24px;
}

.status-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.status-icon {
  font-size: 16px;
  color: #67c23a;
}

.status-text {
  font-size: 14px;
  color: #333;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.progress-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: #e6e6e6;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #409EFF, #6c42e8, #67c23a);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 12px;
  color: #999;
  text-align: right;
}
</style>
